import _ from 'lodash';

const trackingTypes = {
  ROUTE:  'route',
  ACTION: 'action',
};

trackingTypes.ALL = _.values(trackingTypes);

const cleanArray = arr => {
  return _.reduce(
    arr,
    (acc, v, k) => {
      if (!!v) acc.push(v);
      return acc;
    },
    []
  );
};
/**
 * Track a page view in the MX and CS workspaces
 */
const trackPage = ({ pageNameSegments, type, route }) => {
  // make sure analytics is available - it may be turned off in dev or test
  if (window.analytics) {
    // this is where you integrate with segment.io/GA
    if (pageNameSegments) {
      // clean up the page params
      const _page = _.isArray(pageNameSegments) ? cleanArray(pageNameSegments).join(' => ') : pageNameSegments;
      analytics.page(_page);
    }
  }
};

/**
 * Track an action - requires developers to set up a specific tracked action
 * @eventName String - a simple human-readable String to describe the event being tracked
 * @eventPayload Object - a simple non-nested object that contains meaningful tracked data
 */
const trackAction = (eventName, eventPayload) => {
  // make sure analytics is available - it may be turned off in dev or test
  if (window.analytics) {
    // this is where you integrate with segment.io/GA
    analytics.track(eventName, eventPayload);
  }
};

export default { trackPage, trackAction, trackingTypes };
